module.exports = __webpack_public_path__ + "static/img/8.a36f3351.png";